module.exports = __webpack_public_path__ + "static/media/logo.3d341a47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.jpg
// module id = 5728
// module chunks = 0